"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Milestone = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Message = require("../Message");
var _Text = require("../Text");
var _correct = _interopRequireDefault(require("../../assets/images/correct.svg"));
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var Milestone = function Milestone(props) {
  var previewMockData = props.previewMockData,
    shouldHandleDateVariable = props.shouldHandleDateVariable,
    handleVariableShow = props.handleVariableShow,
    handleVariableHide = props.handleVariableHide;
  var richtextProps = {
    previewMockData: previewMockData,
    shouldHandleDateVariable: shouldHandleDateVariable,
    handleVariableShow: handleVariableShow,
    handleVariableHide: handleVariableHide
  };
  var milestones = props.milestones.map(function (v) {
    var _v$description;
    if ((_v$description = v.description) !== null && _v$description !== void 0 && _v$description.buttonGroup) {
      if (v.isFuture || props.disabled) {
        v.description.buttonGroup.disabled = true;
        v.description.disableSpecialLink = true;
        v.description.buttonGroup.buttons.forEach(function (btn) {
          btn.disabled = true;
        });
      }
      v.description.buttonGroup.className = (0, _getPrefixCls.getPrefixCls)('milestone-button-group');
      v.description.buttonGroup.buttons.forEach(function (btn) {
        btn.children = /*#__PURE__*/_react.default.createElement("div", {
          className: "scale"
        }, btn.text);
      });
    }
    return _objectSpread(_objectSpread({}, v), {}, {
      description: v.description
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('milestone'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('milestone__no-padding-bottom'), props.noBottomPadding))
  }, milestones.map(function (v) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('milestone-item'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('milestone-item__future'), v.isFuture)),
      key: v.dateText
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('milestone-item-date')
    }, /*#__PURE__*/_react.default.createElement(_Text.Text, (0, _extends2.default)({
      content: v.dateText
    }, richtextProps)), v.hintText && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, v.hintText))), /*#__PURE__*/_react.default.createElement(Divider, {
      isFuture: v.isFuture
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _getPrefixCls.getPrefixCls)('milestone-item-content')
    }, /*#__PURE__*/_react.default.createElement(_Text.Text, (0, _extends2.default)({
      content: v.title,
      className: "title"
    }, richtextProps)), v.description && /*#__PURE__*/_react.default.createElement(_Message.Message, (0, _extends2.default)({}, v.description, {
      className: "message"
    }, richtextProps))));
  }));
};
exports.Milestone = Milestone;
var Divider = function Divider(props) {
  var isFuture = props.isFuture;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx4.default)((0, _getPrefixCls.getPrefixCls)('milestone-item-divider'), (0, _defineProperty2.default)({}, (0, _getPrefixCls.getPrefixCls)('milestone-item-divider__future'), isFuture))
  }, props.isFuture ? /*#__PURE__*/_react.default.createElement("div", {
    className: "future"
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "past"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _correct.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }));
};